export default "__VITE_ASSET__RLPyBdbt__"